//
//
// Event Booking Bar sticky
//
// See: https://www.codeply.com/p/dEpcghWKEm
//

var fn_event_bookingbar = function () {

  var myBar = $('.js-event-booking-bar');
  var vheight = $(window).height();
  var myLimit = (Math.floor($(window).scrollTop() / vheight)+1) * vheight;

  $(window).scroll(function() {
      if ($(window).scrollTop() > myLimit) {
          myBar.addClass('show');
      } else {
          myBar.removeClass('show');
      }
  });

};
